module.exports = __webpack_public_path__ + "assets/61f1c1b899c8cfeb725728749a34ecba.mp3";